/** Endpoints #33-#34 — re-map trigger and background job progress (§7.5, §8.2). */
import { z } from 'zod';
/** #33 `POST /api/admin/remap` — both filters optional; empty body re-maps everything stale. */
export const RemapBodySchema = z.strictObject({
    scraperId: z.string().min(1).max(100).optional(),
    profileId: z.number().int().positive().optional(),
});
//# sourceMappingURL=jobs.js.map